var _g, _defs, _defs2, _defs3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDep4 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 118,
  height: 96,
  viewBox: "0 0 118 96",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#dep4_svg__filter0_ddi_4438_2779)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50 46.6748C50 46.4447 50.04 46.2247 50.1 46.0047C50.73 48.265 54.46 50.0053 59 50.0053C63.54 50.0053 67.27 48.265 67.9 46.0047C67.96 46.2247 68 46.4447 68 46.6748C68 49.2552 63.97 51.3456 59 51.3456C54.03 51.3456 50 49.2552 50 46.6748ZM59 62.0073C63.97 62.0073 68 59.917 68 57.3366C68 57.1065 67.96 56.8865 67.9 56.6664C67.27 58.9268 63.54 60.6671 59 60.6671C54.46 60.6671 50.73 58.9268 50.1 56.6664C50.04 56.8865 50 57.1065 50 57.3366C50 59.917 54.03 62.0073 59 62.0073ZM59 46.0047C63.97 46.0047 68 43.9143 68 41.3339C68 41.1038 67.96 40.8838 67.9 40.6638C67.27 42.9242 63.54 44.6644 59 44.6644C54.46 44.6644 50.73 42.9242 50.1 40.6638C50.04 40.8838 50 41.1038 50 41.3339C50 43.9143 54.03 46.0047 59 46.0047ZM59 59.3369C63.97 59.3369 68 57.2465 68 54.6661C68 54.4361 67.96 54.216 67.9 53.996C67.27 56.2564 63.54 57.9967 59 57.9967C54.46 57.9967 50.73 56.2564 50.1 53.996C50.04 54.216 50 54.4361 50 54.6661C50 57.2465 54.03 59.3369 59 59.3369ZM59 56.6664C63.97 56.6664 68 54.5761 68 51.9957C68 51.7656 67.96 51.5456 67.9 51.3256C67.27 53.5859 63.54 55.3262 59 55.3262C54.46 55.3262 50.73 53.5859 50.1 51.3256C50.04 51.5456 50 51.7656 50 51.9957C50 54.5761 54.03 56.6664 59 56.6664ZM59 53.996C63.97 53.996 68 51.9057 68 49.3252C68 49.0952 67.96 48.8751 67.9 48.6551C67.27 50.9155 63.54 52.6558 59 52.6558C54.46 52.6558 50.73 50.9155 50.1 48.6551C50.04 48.8751 50 49.0952 50 49.3252C50 51.9057 54.03 53.996 59 53.996ZM59 32.6624C63.97 32.6624 68 30.5721 68 27.9917C68 27.7616 67.96 27.5416 67.9 27.3216C67.27 29.5819 63.54 31.3222 59 31.3222C54.46 31.3222 50.73 29.5819 50.1 27.3216C50.04 27.5416 50 27.7616 50 27.9917C50 30.5721 54.03 32.6624 59 32.6624ZM59 35.3329C63.97 35.3329 68 33.2425 68 30.6621C68 30.4321 67.96 30.212 67.9 29.992C67.27 32.2524 63.54 33.9927 59 33.9927C54.46 33.9927 50.73 32.2524 50.1 29.992C50.04 30.212 50 30.4321 50 30.6621C50 33.2425 54.03 35.3329 59 35.3329ZM59 27.3316C63.97 27.3316 68 25.2412 68 22.6608C68 20.0803 63.97 18 59 18C54.03 18 50 20.0903 50 22.6708C50 25.2512 54.03 27.3416 59 27.3416V27.3316ZM59 30.002C63.97 30.002 68 27.9117 68 25.3312C68 25.1012 67.96 24.8811 67.9 24.6611C67.27 26.9215 63.54 28.6618 59 28.6618C54.46 28.6618 50.73 26.9215 50.1 24.6611C50.04 24.8811 50 25.1012 50 25.3312C50 27.9117 54.03 30.002 59 30.002ZM59 43.3342C63.97 43.3342 68 41.2439 68 38.6634C68 38.4334 67.96 38.2134 67.9 37.9933C67.27 40.2537 63.54 41.994 59 41.994C54.46 41.994 50.73 40.2537 50.1 37.9933C50.04 38.2134 50 38.4334 50 38.6634C50 41.2439 54.03 43.3342 59 43.3342ZM59 38.0033C63.97 38.0033 68 35.913 68 33.3326C68 33.1025 67.96 32.8825 67.9 32.6624C67.27 34.9228 63.54 36.6631 59 36.6631C54.46 36.6631 50.73 34.9228 50.1 32.6624C50.04 32.8825 50 33.1025 50 33.3326C50 35.913 54.03 38.0033 59 38.0033ZM59 40.6738C63.97 40.6738 68 38.5834 68 36.003C68 35.773 67.96 35.5529 67.9 35.3329C67.27 37.5933 63.54 39.3336 59 39.3336C54.46 39.3336 50.73 37.5933 50.1 35.3329C50.04 35.5529 50 35.773 50 36.003C50 38.5834 54.03 40.6738 59 40.6738ZM59 48.6751C63.97 48.6751 68 46.5848 68 44.0043C68 43.7743 67.96 43.5543 67.9 43.3342C67.27 45.5946 63.54 47.3349 59 47.3349C54.46 47.3349 50.73 45.5946 50.1 43.3342C50.04 43.5543 50 43.7743 50 44.0043C50 46.5848 54.03 48.6751 59 48.6751ZM79 48.6751C74.47 48.6751 70.73 46.9348 70.1 44.6744C70.04 44.8945 70 45.1145 70 45.3446C70 47.925 74.03 50.0153 79 50.0153C83.97 50.0153 88 47.925 88 45.3446C88 45.1145 87.96 44.8945 87.9 44.6744C87.27 46.9348 83.54 48.6751 79 48.6751ZM79 54.006C74.47 54.006 70.73 52.2657 70.1 50.0053C70.04 50.2254 70 50.4454 70 50.6754C70 53.2559 74.03 55.3462 79 55.3462C83.97 55.3462 88 53.2559 88 50.6754C88 50.4454 87.96 50.2254 87.9 50.0053C87.27 52.2657 83.54 54.006 79 54.006ZM79 51.3356C74.47 51.3356 70.73 49.5953 70.1 47.3349C70.04 47.5549 70 47.775 70 48.005C70 50.5854 74.03 52.6758 79 52.6758C83.97 52.6758 88 50.5854 88 48.005C88 47.775 87.96 47.5549 87.9 47.3349C87.27 49.5953 83.54 51.3356 79 51.3356ZM79 46.0047C74.47 46.0047 70.73 44.2644 70.1 42.004C70.04 42.224 70 42.4441 70 42.6741C70 45.2545 74.03 47.3449 79 47.3449C83.97 47.3449 88 45.2545 88 42.6741C88 42.4441 87.96 42.224 87.9 42.004C87.27 44.2644 83.54 46.0047 79 46.0047ZM79 39.3336C83.97 39.3336 88 37.2432 88 34.6628C88 32.0823 83.97 29.992 79 29.992C74.03 29.992 70 32.0823 70 34.6628C70 37.2432 74.03 39.3336 79 39.3336ZM79 40.6638C74.47 40.6638 70.73 38.9235 70.1 36.6631C70.04 36.8831 70 37.1032 70 37.3332C70 39.9137 74.03 42.004 79 42.004C83.97 42.004 88 39.9137 88 37.3332C88 37.1032 87.96 36.8831 87.9 36.6631C87.27 38.9235 83.54 40.6638 79 40.6638ZM79 43.3342C74.47 43.3342 70.73 41.5939 70.1 39.3336C70.04 39.5536 70 39.7736 70 40.0037C70 42.5841 74.03 44.6744 79 44.6744C83.97 44.6744 88 42.5841 88 40.0037C88 39.7736 87.96 39.5536 87.9 39.3336C87.27 41.5939 83.54 43.3342 79 43.3342ZM79 56.6664C74.47 56.6664 70.73 54.9262 70.1 52.6658C70.04 52.8858 70 53.1059 70 53.3359C70 55.9163 74.03 58.0067 79 58.0067C83.97 58.0067 88 55.9163 88 53.3359C88 53.1059 87.96 52.8858 87.9 52.6658C87.27 54.9262 83.54 56.6664 79 56.6664ZM39 51.3356C34.47 51.3356 30.73 49.5953 30.1 47.3349C30.04 47.5549 30 47.775 30 48.005C30 50.5854 34.03 52.6758 39 52.6758C43.97 52.6758 48 50.5854 48 48.005C48 47.775 47.96 47.5549 47.9 47.3349C47.27 49.5953 43.54 51.3356 39 51.3356ZM39 48.6651C34.47 48.6651 30.73 46.9248 30.1 44.6644C30.04 44.8845 30 45.1045 30 45.3346C30 47.915 34.03 50.0053 39 50.0053C43.97 50.0053 48 47.915 48 45.3346C48 45.1045 47.96 44.8845 47.9 44.6644C47.27 46.9248 43.54 48.6651 39 48.6651ZM39 45.9947C34.47 45.9947 30.73 44.2544 30.1 41.994C30.04 42.214 30 42.4341 30 42.6641C30 45.2445 34.03 47.3349 39 47.3349C43.97 47.3349 48 45.2445 48 42.6641C48 42.4341 47.96 42.214 47.9 41.994C47.27 44.2544 43.54 45.9947 39 45.9947ZM39 53.996C34.47 53.996 30.73 52.2557 30.1 49.9953C30.04 50.2154 30 50.4354 30 50.6654C30 53.2459 34.03 55.3362 39 55.3362C43.97 55.3362 48 53.2459 48 50.6654C48 50.4354 47.96 50.2154 47.9 49.9953C47.27 52.2557 43.54 53.996 39 53.996ZM39 35.3229C34.03 35.3229 30 37.4132 30 39.9937C30 42.5741 34.03 44.6644 39 44.6644C43.97 44.6644 48 42.5741 48 39.9937C48 37.4132 43.97 35.3229 39 35.3229ZM39 56.6564C34.47 56.6564 30.73 54.9162 30.1 52.6558C30.04 52.8758 30 53.0958 30 53.3259C30 55.9063 34.03 57.9967 39 57.9967C43.97 57.9967 48 55.9063 48 53.3259C48 53.0958 47.96 52.8758 47.9 52.6558C47.27 54.9162 43.54 56.6564 39 56.6564ZM67.45 73.7093H69.12V75.7496H67.45V78H64.84V75.7496H59.58V73.8693L65.25 65.728H67.44V73.7193L67.45 73.7093ZM64.84 69.5486L61.97 73.7093H64.84V69.5486ZM59.06 69.1585H55.98L54.09 71.6289L52.21 69.1585H49.11L52.59 73.4292L48.89 77.98H51.97L54.09 75.2795L56.2 77.98H59.31L55.62 73.4292L59.07 69.1585H59.06Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "dep4_svg__filter0_ddi_4438_2779",
  x: 0,
  y: -12,
  width: 118,
  height: 120,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.808333 0 0 0 0 0.49443 0 0 0 0 0.0235764 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_4438_2779"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 15
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_4438_2779",
  result: "effect2_dropShadow_4438_2779"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_4438_2779",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect3_innerShadow_4438_2779"
})))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dep4_svg__yellow",
  x1: 30.001,
  y1: 18,
  x2: 85.7529,
  y2: 82.4433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#FFDD9A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dep4_svg__gray",
  x1: 30.001,
  y1: 18,
  x2: 85.7529,
  y2: 82.4433,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.15625,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.265625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.3125,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.46875,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.515625,
  stopColor: "#C4C3DD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.604167,
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.875,
  stopColor: "#CECEE0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.973958,
  stopColor: "white"
})))));
export { SvgDep4 as ReactComponent };
export default __webpack_public_path__ + "assets/icons/dep4.d43a93.svg";